import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, Lightning, MapPin, Truck } from "@phosphor-icons/react";

export default function OrderConfirm() {
  const { slug, orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data));
  }, [orderId]);

  if (!order) return <div className="p-8">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#F9F9F9] py-8 px-4">
      <div className="max-w-md mx-auto fade-up">
        <div className="text-center mb-6">
          <div className="inline-flex w-20 h-20 rounded-full bg-[#15803D] items-center justify-center mb-4">
            <CheckCircle weight="fill" size={48} className="text-white" />
          </div>
          <h1 className="font-heading text-3xl font-black tracking-tight">Order placed!</h1>
          <p className="text-gray-600 mt-1">Order #{order.order_number}</p>
        </div>

        <div className="qd-card p-5 bg-[#F8CB46]/10 mb-4 text-center">
          <Lightning weight="fill" size={28} className="text-[#15803D] mx-auto" />
          <div className="font-heading font-black text-2xl mt-2">Arriving in {order.eta_minutes} min</div>
          <div className="text-sm text-gray-600">Pincode {order.pincode} · {order.delivery_mode} delivery</div>
        </div>

        <div className="qd-card p-5 mb-4">
          <h3 className="font-heading font-bold mb-3">Order summary</h3>
          {order.items.map((it) => (
            <div key={it.product_id} className="flex justify-between py-1 text-sm">
              <span>{it.name} × {it.qty}</span>
              <span className="font-semibold">₹{it.price * it.qty}</span>
            </div>
          ))}
          <div className="border-t mt-2 pt-2 space-y-1 text-sm">
            <div className="flex justify-between text-gray-600"><span>Subtotal</span><span>₹{order.subtotal}</span></div>
            <div className="flex justify-between text-gray-600"><span>Delivery</span><span>{order.delivery_charge === 0 ? "FREE" : `₹${order.delivery_charge}`}</span></div>
            <div className="flex justify-between font-heading font-black text-base"><span>Total</span><span>₹{order.total}</span></div>
            <div className="text-xs text-gray-500 mt-1 uppercase">Payment: {order.payment_mode} · {order.payment_status}</div>
          </div>
        </div>

        <div className="qd-card p-5 mb-4">
          <h3 className="font-heading font-bold mb-2 flex items-center gap-2"><MapPin weight="fill" size={16} /> Delivery to</h3>
          <div className="text-sm text-gray-700">
            <div className="font-semibold">{order.address.name}</div>
            <div>{order.address.address}</div>
            <div>{order.address.city} - {order.address.pincode}</div>
            <div className="text-gray-500 mt-1">{order.address.mobile}</div>
          </div>
        </div>

        <Link to={`/${slug}`} className="qd-btn-primary w-full block text-center" data-testid="oc-continue-shop">
          Continue shopping
        </Link>
        <Link to="/my-orders" className="text-center block mt-2 text-sm font-semibold text-[#15803D]" data-testid="oc-view-orders">
          View my orders
        </Link>
      </div>
    </div>
  );
}
